import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logout, AppDispatch } from '../../redux/internal';

export const Logout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const timeUntilRedirectToLogin = Number(process.env.REACT_APP_TIME_REDIRECT_AFTER_LOGOUT);

  useEffect(() => {
    void dispatch(logout());
    const interval = setInterval(() => {
      navigate('/login', { replace: true });
    }, timeUntilRedirectToLogin);

    return () => clearInterval(interval);
  }, [dispatch, navigate, timeUntilRedirectToLogin]);

  return <>You have been logged out.</>;
};
